const War = require('../../entities/War');
const { Age } = require('../../Constants/Constants');
const WarNames = require("../Names/WarNames");

class WarOverTerritory extends War {
    constructor()
    {
        super(
            Age.Age2,
            WarNames.WarOverTerritory,
            "The victor takes 1 yellow token plus 1 yellow token for every 5 points of military advantage from the defeated civilization's yellow bank.",
            2,
            {}
        )
    }
}

module.exports = WarOverTerritory;